<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text class="my-10 px-4 text--bold">
                        {{ $t("pagina-404.texto.no-existe") }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: "Pagina404",
};
</script>
